export default {"src":"/_next/static/media/archeological_zones.e1110e05.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};